// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__XWgnE","layout-body":"style_layout-body__wH3li"};